<!--  -->
<template>
  <div class="follow-up-details">
    <Header
      class="header"
      :title="'跟进详情'"
      :isRightIcon="isRightIcon"
      :isLeftIcon="true"
      @back="$emit('back')"
      @closeBtn="$emit('closeBtn')"
    />
    <div class="follow-card">
      <div class="title">{{ data.createTime | setTime }}跟进结果</div>
      <div class="Tips">
        <div>跟进人: {{ data.creator }}</div>
        <div>跟进时间: {{ data.createTime | setDate }}</div>
      </div>
      <div class="describe">{{data.memo}}</div>
      <ImgList :images="imgList" class="imageList" v-if="imgList.length"/>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Header from "./header.vue";
import ImgList from "../../../components/imgList";
export default {
  props: ["data","isRightIcon"],
  data() {
    return {};
  },

  components: {
    Header,
    ImgList,
  },
  computed: {
    imgList() {
      if (this.data.appendix.length) {
        return this.data.appendix;
      }
      return [];
    },
  },
  filters: {
    setDate(val) {
      return moment(val).format("YYYY-MM-DD HH:mm:ss");
    },
    setTime(val) {
      return moment(val).format("MM月DD日");
    },
  }
};
</script>
<style lang='less' scoped>
.follow-card {
  // background-color: red;
  background-color: #fff;
  margin: 15px 16px 0 16px;
  border: 2px solid #e7f1fe;
  border-radius: 10px;
  overflow: hidden;
}
.follow-up-details {
  background-color: #f4f5f7;
  width: 100%;
  height: 100%;
}
.title {
  background: linear-gradient(180deg, #ffffff 0%, #fafbfb 100%);
  padding: 0 12px;
  height: 49px;
  line-height: 49px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #202636;
}
.Tips {
  padding: 12px 12px 16px 12px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4a5462;
  display: flex;
  justify-content: space-between;
  border: 1px solid #edeff5;
}
.describe {
  padding: 0 12px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #202636;
  margin-top: 16px;
  white-space: pre-wrap	;
  word-break: break-all;
}
.imageList {
  padding: 12px;
}
</style>